import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { dispatch } from "../../../../state/store";
import { setSettingEvents } from "../../../../state/ducks";

import { settingNames } from "../../../../consts";

import { DropdownInput, FlexContainers, WrapperContainer } from "../../../../components";

const SettingSelector = ({ onUpdateChartData }) => {
  const rumSettings = useSelector((store) => store.rum?.settings);

  if (!rumSettings || !rumSettings?.availableSettings?.length) {
    return null;
  }

  const { availableSettings, selectedSetting } = rumSettings;

  const preparedSettings = availableSettings.map((setting) => ({
    id: setting,
    value: settingNames[setting]
  }));

  const handleSelectOption = (selectedId) => {
    dispatch(setSettingEvents({ selectedSetting: selectedId }));
    onUpdateChartData(selectedId);
  };

  return (
    <WrapperContainer Container={FlexContainers.FlexRowStart} gap={8}>
      <DropdownInput
        options={preparedSettings}
        selectedOption={{ id: selectedSetting, value: settingNames[selectedSetting] }}
        onSelectOption={handleSelectOption}
      />
    </WrapperContainer>
  );
};

SettingSelector.propTypes = {
  onUpdateChartData: PropTypes.func.isRequired
};

export default SettingSelector;
